/**
 * Get native language name for ISO language code
 * @param {string} code - ISO 639-1 language code (e.g., 'en', 'uk', 'fr')
 * @returns {string} - Native language name
 */
const getLanguageName = (code) => {
  const languageNames = {
    en: 'English',
    uk: 'Українська',
    pl: 'Polski',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    it: 'Italiano',
    pt: 'Português',
    ru: 'Русский',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    nl: 'Nederlands',
    tr: 'Türkçe',
    sv: 'Svenska',
    da: 'Dansk',
    no: 'Norsk',
    fi: 'Suomi',
    cs: 'Čeština',
    hu: 'Magyar',
    ro: 'Română',
    el: 'Ελληνικά',
    ca: 'Català',
    he: 'עברית',
    th: 'ไทย',
    vi: 'Tiếng Việt',
    id: 'Bahasa Indonesia',
    ms: 'Bahasa Melayu',
    hi: 'हिन्दी',
    bn: 'বাংলা',
    other: 'Other',
  };

  return languageNames[code] || code;
};

export default getLanguageName;
